import { render, staticRenderFns } from "./ChartEdit.vue?vue&type=template&id=621c2be8&scoped=true&"
import script from "./ChartEdit.vue?vue&type=script&lang=js&"
export * from "./ChartEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChartEdit.vue?vue&type=style&index=0&id=621c2be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c2be8",
  null
  
)

export default component.exports